<template>
  <!-- Loading Modal -->
  <div class="modal-messages">
    <div class="inside-modal-messages">
      <div class="row f-row text-center">
        <div
          class="col col-12"
          style="position: absolute; left: 0; top: 30%; z-index: 10000000;"
        >
          <span>Session disconnected due to inactivity</span><br /><br /><br />
          <!-- ============= Buttons =============  -->
          <div class="row f-row">
            <div class="col col-12 text-center align-center ">
              <!--                         
                            <button v-on:click="modal_message.showModalLoading=!modal_message.showModalLoading; emitOK"
                                    class="btn btn-sm btn-home">Cancel
                            </button>               
                            -->
              <button
                v-on:click="
                  modal_message.showModalLoading = !modal_message.showModalLoading
                "
                class="btn btn-sm btn-home"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalIdle",

  data() {
    return {
      logo_white: require("@/assets/images/logo_white.png"),
      logo_blue: require("@/assets/images/logo_blue.png"),
      logo: require("@/assets/images/logo_white.png")
    };
  },
  methods: {
    emitOK() {
      return false;
    }
  }
};
</script>
